import api from './api'
import { Usuario, UsuarioLogin, UsuarioServer } from '../model/Usuario'
import { toUsuario, toUsuarioServer } from './utils'

async function get() {
    try {
        const res = await api.get<UsuarioServer>('/usuarios/')
        const newData = toUsuario(res.data)
        return Promise.resolve(newData)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function login(payload: UsuarioLogin) {
    try {
        const res = await api.post('/api-token-auth/', payload)
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function save(usuario: Usuario) {
    try {
        const payload = toUsuarioServer(usuario)
        const res = await api.post('/usuarios/', payload)
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function update(usuario: Usuario) {
    try {
        const payload = toUsuarioServer(usuario)
        const res = await api.put('/usuarios/', payload)
        const newData = toUsuario(res.data)
        return Promise.resolve(newData)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

export default {
    get,
    login,
    save,
    update
}
